// Centralized brand assets / refs
export const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_coastal-health-plans/artifacts/pmp9z5a9_30a-health-insurance-logo-badge.svg";

export const Logo = ({ className = "h-10 w-auto", alt = "30A Health Insurance" }) => (
  <img src={LOGO_URL} alt={alt} className={className} draggable={false} width="220" height="220" decoding="async" />
);
